<template>
  <div id="box">
    <Header></Header>

<!--    <div style="height: 80px"></div>-->

    <a-row>
      <a-col :span="4"></a-col>
      <a-col :span="16">
        <div style="display:flex;flex-direction: column;width: 100%;margin-top: 30px;">
          <div class="login_title"></div>
          <div class="login">
            <a-form>
              <a-form-item label="" style="margin-bottom: 30px">
                <el-input placeholder="请输入注册手机号码" v-model="form.username" ></el-input>
              </a-form-item>

              <a-form-item label="">
                <el-input placeholder="请输入密码" v-model="form.password" show-password></el-input>
              </a-form-item>

              <a-form-item>
                <a-button style="width: 100%;height: 35px;background:red;border-color:red" type="danger" @click="login">登录
                </a-button>
              </a-form-item>
              <div class="bottom_button" >
                <div style="width: 50%;text-align: left;color:#132b75;" @click="modify()">忘记密码？</div>
                <div style="width: 50%;text-align:right;">没有账号<span style="color:#132b75" @click="homepay">点此注册</span></div>
              </div>
<!--              <div style="display: flex; flex-direction: row; justify-content: center; color:#132b75;line-height: 50px;cursor: pointer" @click="stampui">制图</div>-->
            </a-form>
          </div>
        </div>

      </a-col>
      <a-col :span="4"></a-col>
    </a-row>
    <Footer></Footer>
  </div>
</template>

<script>
import {sendloginemail, conf_list, userlogin, sms_sendSms, Company_getInfo} from "@/api/manage"; // 接口
import Footer from "@/components/footer";
import Header from "@/components/heard";
import {setToken} from "@/utils/auth";

export default {
  name: "paytest",
  components: {Footer , Header},
  props: {},
  data() {
    return {
      show: true,
      codetxt: '获取邮箱验证码',
      current: ["app"],
      configdata: {},
      projectname: "",
      billstatus: 0,
      company: "",
      drawer: 1,
      endtime: null,
      id: "",
      page: 1,
      pagesize: 10,
      service: "all",
      starttime: null,
      status: 0,
      yscode: "",
      codestate: 100,
      Index: 0,
      email: "",
      imgurlas: "",
      sIndexs: 1,
      count: "",
      form: {
        username: "",
        password: "",
      },
    };
  },
  mounted() {

    // if (localStorage.getItem("yscode") != '' && localStorage.getItem("yscode") != null && localStorage.getItem("emailcode") != null && localStorage.getItem("emailcode") != "" && localStorage.getItem("email") != null && localStorage.getItem("email") != "") {
    //   this.$router.push("/user/orderlist");
    // }
    // conf_list({}).then((response) => {
    //   this.configdata = response.data;
    // });
  },
  methods: {
    pictureprocessing() {
      this.$router.push("/seal/index");
    },
    DigitalCertificate() {
      this.$router.push("/");
    },
    handleSubmits() {
      this.$router.push("/login");
    },
    homepay() {
      this.$router.push("/register");
    },
    modify(){
      this.$router.push("/modify");
    },
    login () {
      // this.$router.push("/user/orderlist");
      // return  false
      if (this.form.username.length == 0) {
        this.$alert("请输入登录账号!", "提示");
        return false;
      } else if (this.form.password.length == 0) {
        this.$alert("请输入登录密码！", "提示");
        return false;
      } else {
        userlogin({
          username: this.form.username,
          password: this.form.password,
        }).then((response) => {
          // console.log(response,'12312+++++++');
          if(response.code == 200){
            localStorage.setItem('setToken', response.token)
            // setToken(response.token)
            this.$router.push("/");
            this.$message({
              message: '登录成功！',
              type: 'success'
            });
            Company_getInfo({}).then(response => {
              var obj = response.user;
              obj = JSON.stringify(obj);
              localStorage.setItem('companyinfo', obj)
            })
          }
        })
      }
    },
    verification(e) {
      var mailbox = this.form.email;
      if (mailbox == "" || mailbox == undefined || mailbox == null) {
        this.$alert("请输入下单时预留的手机号", "提示");
        return false;
      }
      if (mailbox.length != 11) {
        this.$alert("预留手机号不正确", "提示");
        return false;
      } else {
        if(this.show == false){
          this.$message({
            message: '请勿重复发送验证码！',
            type: 'warning'
          });
          return false;
        }else{
          let TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            // sms/sendSms
            sms_sendSms({phone: mailbox, yscode: this.form.username}).then((response) => {
              console.log(response,'response')
              this.$message({
                message: '短信验证码已发送，请注意查收！',
                type: 'success'
              });
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            })
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./payTest.css";

b {
  color: #333;
}

#box {
  background-image: url("../../assets/box_bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100vh;
}

#ok .ant-form-item-label label::after {
  content: "";
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.displayssssss {
  display: flex;
  flex-direction: column;
  height: 100px;
  position: relative;
}

.displayssssss p {
  float: right;
  width: 300px;
  text-align: right;
  position: absolute;
  right: 0;
}

/**/
.login {
  display: flex;
  flex-direction: column;
  width: 500px;
  overflow: hidden;
  position: fixed;
  left: 50%;
  top: 30%;
  margin-left: -250px;
  z-index: 999;
}

.login_title{
  display: block;
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 50px;
  font-weight: bold;
  text-align: center;
  font-family: cursive;
}

.bottom_button{
  display: flex;
  flex-direction: row;
  justify-content: center;
  line-height: 50px;
  cursor: pointer


}

</style>
